export const showNextOptionValidator = (option: any) => {
  return {
    validate: value => !(option && (value === '' || value === null)),
    message: 'Please select an option',
  };
};
